import { ActionCallback, apiBase } from '../api';
import { TradingAccount, TradingAccountInfo, TradingPosition, TradingTickerInfo } from '../config/trading';
import { hub } from '../hub';

export class tradingApi extends apiBase {

    public static errorHandler: ActionCallback<string>;

    public static post<TOut>(n: string, i: any = null, host: string = null) {
        host ??= hub.tradingHost;
        return new Promise<TOut>((res: ActionCallback<TOut>, rej: ActionCallback<string>) => {
            apiBase.postData<TOut>('trading/' + n, (r) => {
                if (r.error != null) {
                    if (tradingApi.errorHandler)
                        tradingApi.errorHandler(r.error);
                    rej(r.error);
                } else {
                    res(r.d);
                }
            }, i, host);
        });
    }
    public static getAccounts = () =>
        tradingApi.post<TradingAccount[]>("getAccounts");

    public static updatePosition = (pos: TradingPosition) =>
        tradingApi.post<TradingPosition>("updatePosition", pos);

    public static updateAccount = (acc: TradingAccount) =>
        tradingApi.post<number>("updateAccount", acc);

    public static deleteAccount = (id: number) =>
        tradingApi.post<number>("deleteAccount", id);

    public static getAccountInfo = (id: number) =>
        tradingApi.post<TradingAccountInfo>('getAccountInfo', {
            accountId: id
        });

    public static getTickerInfo = (id: number, tid?: string) =>
        tradingApi.post<TradingTickerInfo>('getTickerInfo', {
            accountId: id,
            tid: tid
        });
}

